<!--
 * @Author:
 * @Description: 移交对象
-->
<template>
  <div class="h-full pt-10px pb-10px">
    <div class="mb-10px flex">
      <el-select
        v-model="standardId"
        placeholder="请选择"
        popper-class="visualization-select-popper"
        :popper-append-to-body="false"
        filterable
        class="mr-10px flex-1"
        @change="changeStandard"
      >
        <el-option
          v-for="item in standardList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        v-model="type"
        placeholder="请选择"
        popper-class="visualization-select-popper"
        :popper-append-to-body="false"
        filterable
        @change="changeType"
        class="w-100px"
      >
        <el-option
          v-for="item in typeList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </div>
    <div class="mb-10px">
      <el-input
        placeholder="请输入搜索关键词"
        v-model="searchKeyword"
        size="small"
        clearable
        @keypress.enter.native="searchByKeyword"
        class="icon-search__input my-5px"
      >
        <i
          slot="append"
          class="el-icon-search cursor-pointer icon-search__input"
          @click="searchByKeyword"
        ></i>
      </el-input>
    </div>
    <div class="mb-10px flex">
      <el-select
        v-model="tagType"
        placeholder="请选择"
        popper-class="visualization-select-popper"
        :popper-append-to-body="false"
        filterable
        class="mr-10px flex-1"
        @change="changeTagType"
      >
        <el-option
          v-for="item in tagTypeList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button size="small" @click="selectChildren">选中子级</el-button>
    </div>
    <div class="tree-box" v-loading="treeLoading" element-loading-background="rgba(0, 0, 0, 0.5)">
      <VirtualTree
        v-if="showTree"
        class="h-full three-tree"
        :expand-on-click-node="false"
        :data="tagTreeList"
        :load="loadNode"
        :props="defaultProps"
        @node-click="handleNodeClick"
        :default-expanded-keys="defaultExpandedIds"
        :lazy="!isExpandAll"
        :default-expand-all="isExpandAll"
        node-key="id"
        ref="tree"
        emptyText="暂无数据"
      >
        <span slot-scope="{ node, data }">
          <span class="w-5px h-16px inline-block">
            <span
              class="w-5px h-5px inline-block rounded-1/2 !bg-[#0082f7] mb-3px"
              v-if="data.isRelated === 1"
            ></span>
          </span>
          <el-tooltip
            :content="`${data.object ? data.object.code : ''}【${data.name}】`"
            placement="top"
            :open-delay="500"
          >
            <span class="truncate ml-5px"
              >{{ data.object ? data.object.code : '' }}【{{ data.name }}】</span
            >
          </el-tooltip>
        </span>
      </VirtualTree>
    </div>
  </div>
</template>

<script>
import { ModelSceneApi } from '@wiz-api/scene-management'
import VirtualTree from '@/components/virtualScrollTree/tree'
import HandoverService from '../../service/HandoverService'

const modelSceneApi = new ModelSceneApi()
export default {
  components: {
    VirtualTree,
  },
  props: {
    player: {
      type: Object,
      default: () => {},
    },
    customProps: {
      type: Object,
      default: () => {},
    },
    modelDetail: {
      type: Object,
      defalut: () => {
        return {
          filePath: '',
          materialFileId: '',
          modelFileId: '', // 模型文件id，云渲染路径又是模型加载名称
        }
      },
    },
    // 对象信息传过来的数据
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  watch: {
    transferProps: {
      async handler(data) {
        if (data && (data.nodeCode || data.code)) {
          this.type = 0
          this.isExact = 1
          this.searchKeyword = data.nodeCode || data.code
          this.showTree = false
          this.$nextTick(() => {
            this.isExpandAll = true
            this.showTree = true
          })
          this.tagTreeList = await this.getTagTree()
          this.findNodePosition(this.tagTreeList, data.nodeCode || data.code)
        }
      },
      deep: true,
      immediate: true,
    },
    'modelDetail.modelFileId': {
      // 广西石化-装置(绑定模型)切换时，重置移交对象
      async handler(newVal, oldVal) {
        if (oldVal) {
          this.searchKeyword = ''
          this.tagType = 0
          this.modelFileId = [newVal]
          this.searchByKeyword()
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      typeList: [
        { name: '上下级', id: 0 },
        { name: '类别树', id: 1 },
        // { name: '系统树', id: 2 },
      ],
      type: 0,
      searchKeyword: '',
      tagTreeList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      treeLoading: false,
      defaultExpandedIds: [],
      isExpandAll: false, // 是否展开全部
      showTree: true,
      currentNode: {}, // 当前节点
      isExact: '',
      standardList: [],
      standardId: '',
      tagType: 0, // 模型对象
      tagTypeList: [
        { name: '模型对象', id: 0 },
        { name: '所有对象', id: 1 },
        { name: '关联对象', id: 2 },
      ],
      modelFileId: [],
    }
  },
  methods: {
    changeTagType() {
      this.searchByKeyword()
    },
    // 修改标准
    changeStandard() {
      this.searchByKeyword()
    },
    // 在对象树里查找当前节点定位
    findNodePosition(data, code) {
      _.map(data, (item) => {
        if (item.object.code === code) {
          this.currentNode = item
          this.handleNodeClick(this.currentNode)
          this.$nextTick(() => {
            this.$refs.tree.setCurrentNode(this.currentNode)
          })
        } else if (item.object.code !== code && item.children.length) {
          this.findNodePosition(item.children, code)
        }
      })
    },
    // 批量计算包围盒
    calcAabb(itemAabb, finalAabb, type) {
      const res = finalAabb
      if (type === 'max') {
        if (res[0] < itemAabb[0]) {
          res[0] = itemAabb[0]
        }
        if (res[1] < itemAabb[1]) {
          res[1] = itemAabb[1]
        }
        if (res[2] < itemAabb[2]) {
          res[2] = itemAabb[2]
        }
      } else {
        if (res[0] > itemAabb[0]) {
          res[0] = itemAabb[0]
        }
        if (res[1] > itemAabb[1]) {
          res[1] = itemAabb[1]
        }
        if (res[2] > itemAabb[2]) {
          res[2] = itemAabb[2]
        }
      }
      return res
    },
    // 选中子级
    async selectChildren() {
      const list = []
      // 查找当前选中节点的所有子级的编码，包括自己
      const [err, res] = await HandoverService.getTagChildren(this.currentNode.id, this.standardId)
      if (!err && res && res.code === 0 && res.data) {
        _.map(res.data, (item) => {
          list.push({ code: item })
        })
      }
      if (list.length === 0) {
        this.$message.warning('当前节点没有子级')
        return
      }
      if (list.length === 1) {
        // 通过位号查找单个节点
        this.findNodeByCode(list[0].code, 1.3)
      } else if (list.length > 1) {
        // 批量通过位号查找节点
        this.batchFindItemByCodes(list)
      }
    },
    // 传递信息给对象信息
    sendInfoToRightDialog(type, data = {}) {
      this.$emit('transferEvent', {
        toCom: { code: 'ObjectInfo', origin: 'HandoverObject', name: '对象信息' },
        type,
        props: {
          ...data,
          standardId: this.standardId,
          openAlarmFlicker: true,
          flickerFrequency: 500,
        },
      })
    },
    // 点击节点
    async handleNodeClick(node) {
      this.currentNode = node
      this.sendInfoToRightDialog('mainComponent', node)
      if (node.object && node.object.code) {
        // 通过位号查找节点
        this.findNodeByCode(node.object.code, 1.1)
      }
    },
    // 通过位号查找单个节点
    async findNodeByCode(code, distance) {
      const codeInfo = await this.player.Native.ModelTree.getItemByCode(decodeURIComponent(code))
      console.log(code, codeInfo, '模型交互参数')
      if (codeInfo && codeInfo.item) {
        // 设置当前选中节点，不触发事件
        this.player.Native.ModelTree.setSelectItem(codeInfo.item)
        // 设置点选时其他节点半透明
        this.player.Native.Settings.set('color.pickup.bkAlpha', 'float', 0.4)
        // 外层添加包裹盒子
        this.player.Native.Settings.set('pickup.highlight', 'bool', true)
        this.player.Native.Settings.set('show.select.box', 'bool', true)
        // 计算节点包围盒
        const { aabb, localMatrix } = await this.player.Native.ModelTree.calcItemAabb(codeInfo.item)
        // 相机移动到包围盒位置
        this.player.Native.Camera.addMoveToAabb(aabb, localMatrix, 5, distance, 2)
      }
    },
    // 批量通过位号查找节点
    async batchFindItemByCodes(list) {
      let nodeList = await this.player.Native.ModelTree.batchFindItemByCode(list)
      // 过滤空节点
      nodeList = nodeList.filter((item) => {
        return !_.isEmpty(item)
      })
      if (nodeList.length === 1) {
        // 通过位号查找单个节点
        this.findNodeByCode(nodeList[0].code, 1.3)
        return
      }
      const aabbItem = []
      _.forEach(nodeList, (node) => {
        aabbItem.push(node.item)
      })
      // 批量设置选中状态
      this.player.Native.ModelTree.setSelectItems(aabbItem)
      // 批量计算节点包围盒
      const aabbList = await this.player.Native.ModelTree.batchCalcItemAabb(aabbItem)
      const finalAabb = [
        [0, 0, 0],
        [0, 0, 0],
      ]
      _.forEach(aabbList, (item) => {
        finalAabb[0] = this.calcAabb(item.aabb.max, finalAabb[0], 'max')
        finalAabb[1] = this.calcAabb(item.aabb.min, finalAabb[1], 'min')
      })
      // const d = Math.sqrt(
      //   Math.pow(finalAabb[0][0] - finalAabb[1][0], 2) +
      //     Math.pow(finalAabb[0][1] - finalAabb[1][1], 2) +
      //     Math.pow(finalAabb[0][2] - finalAabb[1][2], 2)
      // )
      this.player.Native.Camera.moveToAabbWithDistance(finalAabb, 2, 1, 1)
    },
    // 按关键词搜索位号树
    async searchByKeyword() {
      this.isExact = ''
      // 关键字搜索会返回子节点
      if (this.searchKeyword) {
        this.showTree = false
        this.$nextTick(() => {
          this.isExpandAll = true
          this.showTree = true
        })
      } else {
        this.showTree = false
        this.$nextTick(() => {
          this.isExpandAll = false
          this.showTree = true
        })
      }
      this.tagTreeList = await this.getTagTree()
    },
    // 对象树
    async getTagTree(parentCode) {
      this.treeLoading = true
      const params = {
        type: this.type,
        filter: this.searchKeyword, // 关键字模糊查询，支持编码/名称
        code: parentCode, // 父节点
        standardId: this.standardId, // 标准id
        tagType: this.tagType,
      }
      if (this.isExact) {
        params.isExact = this.isExact // 1是精确查询，这时的filter只能是编码code
      }
      if (_.includes([0, 2], this.tagType)) {
        params.modelFileId = this.modelFileId
      }
      const [err, res] = await HandoverService.getTagTree(params)
      this.treeLoading = false
      if (!err && res && res.code === 0 && res.data) {
        const list = await this.findIsNode(_.cloneDeep(res.data))
        return list
      }
      return []
    },
    // 通过位号查找节点
    async findIsNode(data) {
      _.map(data, async (item) => {
        item.isRelated = 0
        const codeInfo = await this.player.Native.ModelTree.getItemByCode(
          decodeURIComponent(item.object.code)
        )
        if (!_.isEmpty(codeInfo)) {
          item.isRelated = 1 // 标记是否已模型
        }
        return item
      })
      return data
    },
    // 懒加载子节点
    async loadNode(node, resolve) {
      this.isExpandAll = false
      if (node.level === 0) {
        return
      }
      let res = []
      if (node.data.object) {
        this.isExact = ''
        res = await this.getTagChildrenByCode(node.data.object.code)
      }
      resolve(res)
    },
    // 修改类型
    changeType() {
      this.searchByKeyword()
    },
    async getStandardList() {
      const [err, res] = await HandoverService.getStandardList()
      if (!err && res && res.code === 0 && res.data) {
        this.standardList = res.data
        this.standardId = res.data[0].id
      } else {
        this.standardList = []
        this.standardId = ''
      }
    },
    // 对象树根据code，获取下一级
    async getTagChildrenByCode(parentCode) {
      this.treeLoading = true
      const params = {
        type: this.type,
        filter: this.searchKeyword, // 关键字模糊查询，支持编码/名称
        code: parentCode, // 父节点
        standardId: this.standardId, // 标准id
        tagType: this.tagType,
      }
      if (this.isExact) {
        params.isExact = this.isExact // 1是精确查询，这时的filter只能是编码code
      }
      if (_.includes([0, 2], this.tagType)) {
        params.modelFileId = this.modelFileId
      }
      const [err, res] = await HandoverService.getTagChildrenByCode(params)
      this.treeLoading = false
      if (!err && res && res.code === 0 && res.data) {
        const list = await this.findIsNode(_.cloneDeep(res.data))
        return list
      }
      return []
    },
    // 获取模型文件id
    async getModelFileId() {
      this.modelFileId = []
      const sceneId = localStorage.getItem('sceneId')
      if (!sceneId) return
      const [jsonErr, jsonRes] = await modelSceneApi.getModelSecenRelatedJson({ id: sceneId })
      if (!jsonErr) {
        const jsonData = JSON.parse(jsonRes)
        _.map(jsonData.children, (item) => {
          this.modelFileId.push(item.code.modelFileId)
        })
      }
    },
  },
  async created() {
    if (this.$route.query.modelInfoId) {
      this.modelFileId = [this.$route.query.modelInfoId]
    } else if (this.$route.query.proj && this.$route.query.proj === 'gx') {
      // 广西石化三维功能，使用移交对象
      this.modelFileId = [this.modelDetail.modelFileId]
    } else {
      await this.getModelFileId()
    }
    await this.getStandardList()
    this.searchByKeyword()
  },
  async beforeDestroy() {
    // 取消选中节点
    await this.player.Native.ModelTree.setSelectItem(0)
  },
}
</script>

<style lang="scss" scoped>
.tree-box {
  padding: 10px;
  height: calc(100% - 140px);
  border: 1px solid #45f2eb33;
}

::v-deep.three-tree {
  overflow-y: auto;
  height: 100%;
  color: #fff;
  background-color: transparent !important;

  .el-tree-node__content:hover {
    background: #005d657f !important;
  }

  .el-tree-node.is-current > .el-tree-node__content {
    background: #005d657f !important;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background: #005d657f !important;
  }

  .custom-tree-node {
    width: 100%;
    font-size: 14px;
  }
}
::v-deep .el-button {
  background: var(--cockpitButtonBg) !important;
  color: #fff !important;
}
</style>
